module.exports = __webpack_public_path__ + "static/media/04.57cbc4ff.jpg";